module.exports = __webpack_public_path__ + "media/CN_020.41649aa8.mp3";